// Common
import { Modal } from "bootstrap";

// Common
import { default as init } from "./common/base";

// Helpers
import { Component } from "./helpers/component";

// Components
import { Slider } from "../../components/slider/slider";
import { Share } from "../../components/share/share";
import { Menu } from "../../components/menu/menu";
import { HeroVideo } from "../../components/herovideo/herovideo";
import { BlockVideo } from "../../components/blockvideo/blockvideo";

//import { Header } from "../../components/header/header";
import Swiper from "swiper";

// Registering components
//Component.register("Header", Header);
Component.register("Slider", Slider);
Component.register("Share", Share);
Component.register("Menu", Menu);
Component.register("HeroVideo", HeroVideo);
Component.register("BlockVideo", BlockVideo);

init();

document.addEventListener('DOMContentLoaded', () => {

  $(`.c-introsection__list--item`).click(function(){
    if (!$(this).hasClass('active')){
      $(`.c-introsection__list--item`).removeClass('active');
      $(this).addClass('active');
    }
  });

  var $heroslider = $('.c-heroslider.--frontpage');
  if ( $heroslider.length > 0 ) {
    var $header = $('.c-header');
    var $innerHeader = $('.c-header__inner');
    var elementTop = $heroslider.offset().top;
    var elementHeight = $heroslider.outerHeight();
    var headerHeight = $innerHeader.outerHeight();
    var elementBottom = (elementTop + elementHeight) - headerHeight;

    $(window).resize(function(){
      elementTop = $heroslider.offset().top;
      elementHeight = $heroslider.outerHeight();
      headerHeight = $innerHeader.outerHeight();
      elementBottom = (elementTop + elementHeight) - headerHeight;
    });

    $(window).scroll(function(){
      const currentScroll = $(window).scrollTop();
      if ( currentScroll >= elementBottom ) {
        if ( $header.hasClass('--ishomehero')) {
          $header.removeClass('--ishomehero');
        }
      } else {
        if ( !$header.hasClass('--ishomehero')) {
          $header.addClass('--ishomehero');
        }
      }

    });
  }

  //Read More toggle
  $(`.product_descr_readmore_more`).click(function(){
    event.preventDefault();
    var readmoreblock = $(`.product_descr_readmore`);
    if (!readmoreblock.hasClass('active')){
      readmoreblock.addClass('active');
    }
  });
  $(`.product_descr_readmore_less`).click(function(){
    event.preventDefault();
    var readmoreblock = $(`.product_descr_readmore`);
    if (readmoreblock.hasClass('active')){
      readmoreblock.removeClass('active');
    }
  });
  //Search
  $(`.c-search__btn-toggle`).click(function(){
    event.preventDefault();
    var searchblock = $(`.c-blocksearch`);
    if (!searchblock.hasClass('active')){
      $(this).addClass('active');
      searchblock.addClass('active');
    }
  });

  $(`.c-search-btn-toggleclose`).click(function(){
    event.preventDefault();
    var searchblock = $(`.c-blocksearch`);
    if (searchblock.hasClass('active')){
      $(this).removeClass('active');
      searchblock.removeClass('active');
    }
  });

  //Cart
  $(`.c-cart__btn-toggle`).click(function(){
    event.preventDefault();
    var searchblock = $(`.c-cart`);
    var body = $('body');
    if (!searchblock.hasClass('active')){
      $(this).addClass('active');
      searchblock.addClass('active');
    }
    if ( !body.hasClass('zaux-cart-active') ) {
      body.addClass('zaux-cart-active');
    }
  });

  $(`.c-cart-btn-toggleclose`).click(function(){
    event.preventDefault();
    var searchblock = $(`.c-cart`);
    var body = $('body');
    if (searchblock.hasClass('active')){
      $(this).removeClass('active');
      searchblock.removeClass('active');
    }
    if ( body.hasClass('zaux-cart-active') ) {
      body.removeClass('zaux-cart-active');
    }
  });

  //Share toogle
  $(`.c-share__btn-toggle`).click(function(){
    event.preventDefault();
    var shareblock = $(`.c-heroshop__sharebox`);
    if (!shareblock.hasClass('active')){
      $(this).addClass('active');
      shareblock.addClass('active');
    } else {
      $(this).removeClass('active');
      shareblock.removeClass('active');
    }
  });

  // Shop - single product current image
  $(`.c-heroshop__content--listimg--item button`).click(function(){
    event.preventDefault();
    var parent = $(this).parent();
    if ( !$(this).hasClass('active') ) {
      $(`.c-heroshop__content--listimg--item button`).removeClass('active');
      $(`.c-heroshop__content--listimg--item`).removeClass('active');
      $(this).addClass('active');
      parent.addClass('active');
    }

    var current_main_img = $(".c-heroshop__content--mainimg .c-heroshop__content--mainimg--front img");
    var current_clickd_img_src = $(this).find("img").attr("src");
    current_main_img.attr("src",current_clickd_img_src);
    console.log(current_main_img.attr('src',current_clickd_img_src))

  });

//ScrollTop ancore
$('a[href="#Prenota"]').click(function(){
    // event.preventDefault();
    var offset = $('#Prenota').offset();
    var scrollto = offset.top;
    $('html, body').animate({scrollTop:scrollto}, 1000);
});
    $('[data-fancybox="gallery"]').fancybox({
      openEffect  : 'fade',
      closeEffect : 'fade',
      helpers: {
          title : {
              type : 'inside'
          },
          overlay: {
              locked: false // Elimina il problema dell scroll verso il top all'apertura
          },
          media : {
          }
      }
  });


  function updatePaginationClass() {
    var $paginationElement = $('.pagination-heroshop');

    if ($paginationElement.length) {
      if ($(window).width() < 992) {
        if ( $paginationElement.hasClass('swiper-pagination-vertical') ) {
          $paginationElement.removeClass('swiper-pagination-vertical').addClass('swiper-pagination-horizontal');
        }
      } else {
        if ( $paginationElement.hasClass('swiper-pagination-horizontal') ) {
          $paginationElement.removeClass('swiper-pagination-horizontal').addClass('swiper-pagination-vertical');
        }
      }
    }
  }
  $(window).resize(updatePaginationClass);

});
